import React from "react";
import { Box, Button } from "@material-ui/core";
import { WifiTethering as SensorsIcon } from "@material-ui/icons";

const SensorAssignActionBtn = ({
  buttonHandler,
  selectedData,
  labels = [
    { name: "Bulk Assign", action: "assign", color: "primary" },
    { name: "Bulk Unassign", action: "unassign", color: "secondary" },
  ],
}) => {
  return (
    <Box
      style={{
        display: "flex",
        gap: 8,
      }}
    >
      {labels.map((label) => (
        <Button
          key={label.action}
          variant="outlined"
          fullWidth
          color={label.color}
          startIcon={<SensorsIcon />}
          onClick={() =>
            buttonHandler({ label: label.name, value: label.action })
          }
          style={{
            fontWeight: 600,
            textTransform: "none",
            borderRadius: 8,
            visibility: selectedData.length ? "visible" : "hidden",
          }}
        >
          {label.name} ({selectedData.length})
        </Button>
      ))}
    </Box>
  );
};

export default SensorAssignActionBtn;
